module.exports = __webpack_public_path__ + "09_mole.e4a29b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer3/09_mole.png
// module id = 6jLD
// module chunks = 0